import { INavStyles, MessageBar, MessageBarType, Nav, Stack } from '@fluentui/react';
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { LeftNav } from '../components/layout/leftnav';
import { useAuthenticationContext } from '../providers/authenticationprovider';
const Settings: React.FunctionComponent<{}> = () => {

  const navStyles: Partial<INavStyles> = {
    root: {
      width: 308,
      boxSizing: 'border-box',
      background: "#fefefe",
      overflowY: 'auto',
    },
    chevronButton: {
      right: 0,
      left: "unset"
    }
  };

  const authContext = useAuthenticationContext();

  return (
    <div className="home">
      {authContext?.Result?.KeplerAuthStatus?.isKeplerAdministrator ? <>
        <Stack horizontal>
        <LeftNav />
          <Stack.Item grow>
            <div style={{ paddingLeft: 10 }}>
              <Outlet />
            </div>
          </Stack.Item>
        </Stack>
      </> : <MessageBar messageBarType={MessageBarType.error}>Access denied</MessageBar>}
    </div>
  );
}

export default Settings;
